import {
  type LapDto,
  type Track,
  type TrackSessionDto,
  type TrackSession,
  processTrackSessionWithTrackDto,
} from '@pitbrain/shared'

export const mapToTrackSession = async (
  dto: TrackSessionDto,
  track: Track,
  sharedLaps: LapDto[]
): Promise<TrackSession> => {
  const { trackSession } = await processTrackSessionWithTrackDto(dto, track)
  trackSession.sharedLapIds = new Set(sharedLaps.map((lap) => lap.id))
  return trackSession
}
